export default {
    install: (app, options) => {

        // Vue.getCurrencyInfo = () => {
        //     return {
        //         prefix: '',
        //         exchangeRate: 4.6,
        //         suffix: ' zł'
        //     }
        // };

        app.config.globalProperties.$numberHelper = {
            formatMoney: (value) => {
                const localeData = {
                    pl: {
                        localeString: 'fr-FR',
                        suffix: ' zł'
                    },
                    en: {
                        localeString: 'be-BE',
                        suffix: ' EUR'
                    },
                    nl: {
                        localeString: 'be-BE',
                        suffix: ' EUR'
                    }
                }
                const valueFormatted = parseInt(value).toLocaleString(localeData[process.env.MIX_APP_LOCALE].localeString);
                const suffix = localeData[process.env.MIX_APP_LOCALE].suffix;
                return valueFormatted + suffix
            },
            formatMoneyWithDecimals: (value) => {
                const localeData = {
                    pl: {
                        localeString: 'fr-FR',
                        suffix: ' zł'
                    },
                    en: {
                        localeString: 'be-BE',
                        suffix: ' EUR'
                    },
                    nl: {
                        localeString: 'be-BE',
                        suffix: ' EUR'
                    }
                }
                const valueAsNumber = Number(value);
                const valueFormatted = valueAsNumber.toLocaleString(localeData[process.env.MIX_APP_LOCALE].localeString, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                const suffix = localeData[process.env.MIX_APP_LOCALE].suffix;
                return valueFormatted + suffix
            },
            formatMoneyObject: (value, inline = false) => {
                const localeData = {
                    pl: {
                        separator: ' ',
                        suffix: ' zł'
                    },
                    en: {
                        separator: ',',
                        suffix: ' EUR'
                    },
                    nl: {
                        separator: '.',
                        suffix: ' EUR'
                    }
                }

                let valueFormatted = Math.abs(Math.round(value)).toFixed(0);
                let parts = [];

                while (valueFormatted.length > 3) {
                    parts.unshift(valueFormatted.slice(-3));
                    valueFormatted = valueFormatted.slice(0, -3);
                }

                if (valueFormatted.length > 0) {
                    parts.unshift(valueFormatted);
                }

                let result = parts.join(localeData[process.env.MIX_APP_LOCALE].separator);
                let suffix = localeData[process.env.MIX_APP_LOCALE].suffix;

                if (value < 0) {
                    result = '-' + result;
                }

                return inline ? result + ' ' + suffix : {value: result, suffix: suffix};
            },
            formatMoneyAsString: (value) => {
                const localeData = {
                    pl: {
                        separator: ' ',
                        suffix: ' zł'
                    },
                    en: {
                        separator: ',',
                        prefix: '€ '
                    },
                    nl: {
                        separator: '.',
                        prefix: '€ '
                    }
                }

                let valueFormatted = Math.abs(Math.round(value)).toFixed(0);
                let parts = [];

                while (valueFormatted.length > 3) {
                    parts.unshift(valueFormatted.slice(-3));
                    valueFormatted = valueFormatted.slice(0, -3);
                }

                if (valueFormatted.length > 0) {
                    parts.unshift(valueFormatted);
                }

                let result = parts.join(localeData[process.env.MIX_APP_LOCALE].separator);
                let prefix = localeData[process.env.MIX_APP_LOCALE].prefix;
                let suffix = localeData[process.env.MIX_APP_LOCALE].suffix;

                if (value < 0) {
                    result = '-' + result;
                }

                if (suffix) {
                    result = result + suffix;
                }

                if (prefix) {
                    result = prefix + result;
                }

                return result;
            },
            formatNumber: (value) => {
                return parseInt(value).toLocaleString('fr-FR');
            },
            addVat: (value, vatRate) => {
                return value * vatRate;
            }
        };

// that's for IE11 being retarded
//         Vue.prototype.$numberHelper.convertAndFormatMoney = methods.convertAndFormatMoney;
//         Vue.prototype.$numberHelper.convertAndFormatMoneyWithDecimals = methods.convertAndFormatMoneyWithDecimals;
//         Vue.prototype.$numberHelper.formatNumber = methods.formatNumber;
//         Vue.prototype.$numberHelper.formatMoney = methods.formatMoney;
//         Vue.prototype.$numberHelper.addVat = methods.addVat;
//         Vue.prototype.$numberHelper.currencyInfo = Vue.getCurrencyInfo();


    }
}
